/**
 * useTenants
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import TenantsContext from './tenants-context'

const useTenants = () => {
  const context = useContext(TenantsContext)
  return context
}

export default useTenants
